export default (obj, value, path) => {
    // 
    var i;
    let patharr = path.split(/\/|\./);
    for (i = 1; i < patharr.length - 1; i++) {
        if (obj[patharr[i]]) {
            obj = obj[patharr[i]];
        } else {
            obj[patharr[i]] = {}
            obj = obj[patharr[i]];
        }
    }
    obj[patharr[i]] = value;
}
